<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <b-table
            id="lottery-systems-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(k)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(n)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(master_code)="data">{{ $t(data.label) }}</template>

            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'lottery-systems-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import tableMixin from "@/shared/mixins/table.mixin";
import { errorConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect
  },
  name: "lotterySystems",
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "lotterySystems",

      bulkAction: null,
      bulkActionOptions: [
        {
          text: "Activate System",
          field: "active",
          value: true
        },
        {
          text: "Disable System",
          field: "active",
          value: false
        },
        {
          text: "Allow Scan Next",
          field: "allow_scan_next",
          value: true
        },
        {
          text: "Prevent Scan Next",
          field: "allow_scan_next",
          value: false
        },
        {
          text: "Allow Automatic Processing",
          field: "automatic_processing",
          value: true
        },
        {
          text: "Prevent Automatic Processing",
          field: "automatic_processing",
          value: false
        },
        { text: "Delete", field: "delete", value: true }
      ],

      filterOptions: [
        {
          field: "active",
          multiple: false,
          placeholder: "Active",
          options: [
            { name: "Active Systems", value: true },
            { name: "Inactive Systems", value: false }
          ],
          selected: []
        },
        {
          field: "allow_scan_next",
          multiple: false,
          placeholder: "Scan Next",
          options: [
            { name: "Allow Scan Next", value: true },
            { name: "Prevent Scan Next", value: false }
          ],
          selected: []
        },
        {
          field: "automatic_processing",
          multiple: false,
          placeholder: "Processing",
          options: [
            { name: "Allow Automatic Processing", value: true },
            { name: "Prevent Automatic Processing", value: false }
          ],
          selected: []
        }
      ],

      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "name", sortable: true, class: "" },
        { key: "r", sortable: true, class: "" },
        { key: "n", sortable: true, class: "" },
        { key: "k", sortable: true, class: "" },
        { key: "m", sortable: true, class: "" },
        { key: "master_code", sortable: true, class: "" },
        { key: "liability", sortable: true, class: "", ignore: true },
        { key: "odds", sortable: true, class: "", ignore: true },
        { key: "active", sortable: true, class: "", ignore: true },
        {
          key: "allow_scan_next",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        {
          key: "automatic_processing",
          sortable: true,
          class: "d-none",
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "Add lottery system"
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["lotterySystem/endpoint"];

      return `${apiUrl}/${endpoint}s?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eid", "esystem_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "lottery-systems-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      if (this.bulkAction.field == "delete") {
        this.$store
          .dispatch("lotterySystem/delete", this.selected)
          .finally(() => {
            loading.close();
            this.allSelected = false;
            this.selected = [];
            this.refresh();
          });
      }

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("lotterySystem/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.selected.length) {
          exactFields.push(item.field);
          exactValues.push(item.selected);
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      this.$store
        .dispatch("lotterySystem/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          resp.data.rows.forEach((item, index) => {
            resp.data.rows[index]["_cellVariants"] = {};
            if (item.active) {
              resp.data.rows[index]["_cellVariants"]["active"] = "success";
            } else {
              resp.data.rows[index]["_cellVariants"]["active"] = "danger";
            }
            if (item.allow_scan_next) {
              resp.data.rows[index]["_cellVariants"]["allow_scan_next"] =
                "success";
            } else {
              resp.data.rows[index]["_cellVariants"]["allow_scan_next"] =
                "danger";
            }
            if (item.automatic_processing) {
              resp.data.rows[index]["_cellVariants"]["automatic_processing"] =
                "success";
            } else {
              resp.data.rows[index]["_cellVariants"]["automatic_processing"] =
                "danger";
            }
          });
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/lottery-systems/" + item.eid);
    },
    redirect() {
      this.$router.push("/lottery-systems/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


